var _path, _path2, _path3, _path4, _path5, _path6;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgWebsite(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 22,
    viewBox: "0 0 22 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.2654 12.125H8.73465C8.75855 13.6016 8.97771 15.0692 9.3868 16.4899L10.3918 19.9801C10.5928 19.9933 10.7956 20 11 20C11.2044 20 11.4072 19.9933 11.6082 19.9801L12.6132 16.4899C13.0223 15.0692 13.2415 13.6016 13.2654 12.125Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M14.118 19.4541C17.2506 18.3163 19.5742 15.5131 20 12.125H15.5332C15.5091 13.8107 15.2605 15.4863 14.7935 17.1081L14.118 19.4541Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M15.5332 9.875L20 9.875C19.5742 6.48694 17.2506 3.68372 14.118 2.54588L14.7935 4.89195C15.2605 6.51372 15.5091 8.18929 15.5332 9.875Z",
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M11.6082 2.01992C11.4072 2.00671 11.2044 2 11 2C10.7956 2 10.5928 2.00671 10.3918 2.01992L9.3868 5.51007C8.97771 6.93082 8.75855 8.39836 8.73465 9.875L13.2654 9.875C13.2415 8.39836 13.0223 6.93082 12.6132 5.51007L11.6082 2.01992Z",
    fill: "white"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M7.20651 17.1081L7.88204 19.4541C4.74945 18.3163 2.42578 15.5131 2 12.125H6.46685C6.49092 13.8107 6.73953 15.4863 7.20651 17.1081Z",
    fill: "white"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M6.46685 9.875H2C2.42578 6.48694 4.74945 3.68372 7.88204 2.54588L7.20651 4.89195C6.73953 6.51372 6.49092 8.18929 6.46685 9.875Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWebsite);
export default __webpack_public_path__ + "static/media/website.c6a6bfa4e10be96fb43dd8fe08761cd1.svg";
export { ForwardRef as ReactComponent };